export default __webpack_public_path__ + "static/media/lprActivity.195ea12f.png";